import { render, staticRenderFns } from "./DialogsAlert.vue?vue&type=template&id=186268d3"
import script from "./DialogsAlert.vue?vue&type=script&lang=js"
export * from "./DialogsAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports